import * as api from '../api'

export default async experience => {
  const siteUid = experience.siteId
  const xpLink = '/site/' + siteUid + '/experience/' + experience._id
  const checkResult = {
    errors: [],
    warnings: [],
    nb: 0
  }
  checkResult.nb++
  const tracks = await api.tracks.getFrom('experiences', experience._id)
  if (!experience.startTrack && tracks.length > 1) {
    checkResult.errors.push({
      text: "Plusieurs parcours sont définis, mais aucun n'est déclaré comme parcours de départ dans l'expérience.",
      link: xpLink
    })
  }
  checkResult.nb++
  if (!experience.picture) {
    checkResult.warnings.push({
      text: "L'expérience n'a pas d'image.",
      link: xpLink
    })
  }

  if (experience.routes) {
    for (let counter = 0; counter < experience.routes.length; counter++) {
      const { segment } = experience.routes[counter]
      if (!segment) {
        checkResult.errors.push({
          text: `Le tracé GPS ${counter + 1} de l'expérience n'a pas de tracé.`,
          link: xpLink
        })
      } else {
        const r = await api.segments.get(segment)
        if (!r) {
          checkResult.errors.push({
            text: `Le tracé GPS ${counter + 1} de l'expérience n'existe pas.`,
            link: xpLink
          })
        }
      }
    }
  }

  // let modules = await api.modules.getFrom('experiences', experience._id)

  const hasAdventure = !!(tracks || []).find(t => t.type === 'adventure')
  const hasCompass = (tracks || []).find(t => !!(t.points || []).find(p => p.check && p.check.type === 'qrcode'))
  /* let hasVoice = (modules || []).find(module => {
    return (module.dialogs || []).find(d => !!d.sound)
  }) */

  checkResult.nb++
  if (!experience.theme) {
    checkResult.warnings.push({
      text: "L'expérience n'a pas de thème défini.",
      link: xpLink + '/theme'
    })
  } else {
    const colors = ['color_primary', 'color_accent']

    const missingColors = experience.theme.colors ? colors.filter(key => !experience.theme.colors[key]) : colors

    checkResult.nb++
    if (missingColors.length > 0) {
      checkResult.warnings.push({
        text: `Il manque ${missingColors.length} couleur(s) : ${missingColors.join(', ')}.`,
        link: xpLink + '/theme'
      })
    }

    let resources = ['map_marker']
    if (hasCompass) {
      resources = resources.concat([
        'compass_background',
        'compass_needle',
        'point_check_background',
        'point_check_clues_normal',
        'point_check_found_normal'
      ])
    }
    if (hasAdventure) {
      resources.push('adventure_progress_background')
    }
    const missingRessources = experience.theme.assets ? resources.filter(key => !experience.theme.assets[key]) : resources

    checkResult.nb++
    if (missingRessources.length > 0) {
      checkResult.warnings.push({
        text: `Il manque ${missingRessources.length} ressource(s) : ${missingRessources.join(', ')}.`,
        link: xpLink + '/theme',
        _id: experience._id
      })
    }
  }
  return Promise.resolve(checkResult)
}
